var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"dateInput",attrs:{"type":"date"},domProps:{"value":_vm.localDate}}),_c('input',{ref:"timeInput",attrs:{"type":"time","step":"0.001"},domProps:{"value":_vm.localTime}})])}
var staticRenderFns = []

export { render, staticRenderFns }